module.exports = __webpack_public_path__ + "static/img/V-M60@2x.5ce3efaf.png";